import { ToolCall, ToolResponse } from 'src/api/chat';

import { AppointmentScheduler } from './appointmentScheduler';
import { FileUploader } from './fileUploader';

export type ToolProps<Args = any> = Omit<ToolCall, 'args'> & {
  response?: ToolResponse;
  args: Partial<Args>;
  onComplete: (
    payload: Omit<ToolResponse<Partial<Args>>, 'name' | 'type' | 'id'>
  ) => Promise<void>;
};

export const tools: Record<ToolCall['name'], React.ComponentType<ToolProps>> = {
  ask_appointment_details: AppointmentScheduler,
  ask_file_upload: FileUploader,
};
